"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AttachmentUrlUploadHandler", {
    enumerable: true,
    get: function() {
        return AttachmentUrlUploadHandler;
    }
});
const _common = require("@nestjs/common");
const _constants = require("~/constants");
const _Jobs = require("~/interface/Jobs");
const _eventemitterinterface = require("~/modules/event-emitter/event-emitter.interface");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let AttachmentUrlUploadHandler = class AttachmentUrlUploadHandler {
    onModuleInit() {
        this.unsubscribe = this.eventEmitter.on(_constants.EMIT_EVENT.HANDLE_ATTACHMENT_URL_UPLOAD, async (arg)=>{
            try {
                await this.jobsService.add(_Jobs.JobTypes.AttachmentUrlUpload, arg);
            } catch (e) {
                this.logger.error({
                    error: e
                });
            }
        });
    }
    onModuleDestroy() {
        this.unsubscribe == null ? void 0 : this.unsubscribe.call(this);
    }
    constructor(eventEmitter, jobsService){
        this.eventEmitter = eventEmitter;
        this.jobsService = jobsService;
        this.logger = new _common.Logger(AttachmentUrlUploadHandler.name);
    }
};
AttachmentUrlUploadHandler = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)('IEventEmitter')),
    _ts_param(1, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _eventemitterinterface.IEventEmitter === "undefined" ? Object : _eventemitterinterface.IEventEmitter,
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService
    ])
], AttachmentUrlUploadHandler);
